const personal = {
  '--primary': '#41273b',
  '--secondary': '#72246c',
  '--tertiary': '#963cbd',
};
export default personal;
